import RequestPageTwo from "./RequestPageTwo";

const HealthFound = () => {
    return (
        <RequestPageTwo title="Health Found Request Form"
            fetchUrl="/get-sangha-health-fund-requests"
            editEndpoint="update-sangha-health-fund-requests"
            deleteEndpoint="sangha-health-fund-requests"
            statusEndpoint="update-sangha-health-fund-requests" />
    );
}

export default HealthFound;
